type Props = {
  currentLength: number;
  maxLength: number;
};

const Count = ({ currentLength, maxLength }: Props) => {
  return (
    <div className="txt_byte">
      <span className="screen_out">현재 글자수 :</span>
      <span className="num_byte num_write">{currentLength}</span>
      <span className="txt_bar">/</span>
      <span className="screen_out">최대 글자수 :</span>
      <span className="num_byte max_len">{maxLength}</span>
    </div>
  );
};

export default Count;
